import type { TimeRangeInputValue, TimeRangeValue } from '@chronosphereio/core';

export const DEFAULT_TIME_RANGE: TimeRangeValue = { pastDuration: '1h' };

/**
 * Represents "last 1 hour".
 */
export const DEFAULT_TIME_RANGE_INPUT_VALUE: TimeRangeInputValue = { start: 'now-1h', end: 'now' };
